import { render } from "./SuscripcionList.vue?vue&type=template&id=36fe9f89&scoped=true"
import script from "./SuscripcionList.vue?vue&type=script&lang=js"
export * from "./SuscripcionList.vue?vue&type=script&lang=js"

import "./SuscripcionList.vue?vue&type=style&index=0&id=36fe9f89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fe9f89"]])

export default __exports__